import React, { useState, useEffect } from "react";
import { GraduationCap, BookOpen } from "lucide-react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./ASGConnect2024.css";
import ASGConnect2025Registration from "./ASGConnect2025Registration";
import ProgrammeOutline from "./ProgrammeOutline";
import { color } from "framer-motion";

const images = [
  "images/banners/ASG-CONFERENCE2025.jpeg",
  //"images/banners/banner-asg-conference.jpg",
];

const newsData = [
  {
    id: 1,
    image: "images/Executives/kofi-NTIM.png",
  },
  {
    id: 2,
    image: "images/Executives/DR.ZAKARIA.png",
  },
  {
    id: 3,
    image: "images/Executives/CHRISTOPHER-BOADI-MENSAH.png",
  },
  {
    id: 4,
    image: "images/Executives/EVELYN-ADJEI.png",
  },
  {
    id: 5,
    image: "images/Executives/francis-Nketia.png",
  },
  {
    id: 6,
    image: "images/Executives/ISAAC-SENIOR.png",
  },
  {
    id: 7,
    image: "images/Executives/kakra-starlife.png",
  },
  {
    id: 8,
    image: "images/Executives/CHRISTIAN-SHEPLEY.png",
  },
  {
    id: 9,
    image: "images/Executives/KWABENA-OSEI-MENSAH.png",
  },
  {
    id: 10,
    image: "images/Executives/THOMAS-LOLE.png",
  },
  {
    id: 11,
    image: "images/Executives/HENRY-MBUTHIA.png",
  },
  {
    id: 12,
    image: "images/Executives/YVONNE-PALM.png",
  },
];

const ASGConnect2025 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [currentIndex, setCurrentIndex] = useState(0);
  // Modal visibility state
  const [showModal, setShowModal] = useState(false);
  const [showProgrammeOutline, setShowProgrammeOutline] = useState(false);

  // Automatic scrolling every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextNews();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  // Next news card
  const nextNews = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % newsData.length);
  };

  // Previous news card
  const prevNews = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + newsData.length) % newsData.length
    );
  };

  // Slice to show 3 cards
  const visibleNews = [
    newsData[currentIndex],
    newsData[(currentIndex + 1) % newsData.length],
    newsData[(currentIndex + 2) % newsData.length],
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <section className="section-categories">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">ASG CONFERENCE</h2>
        <div className="sectionbottom-line"></div>
      </section>
      <div className="newscard">
        <div
          className="banner"
          style={{
            backgroundImage: `url(${images[currentImageIndex]})`,
            height: "500px",
            marginBottom: "20px",
          }}
        ></div>
        <div className="parag">
          <p>
            <span style={{ fontWeight: "bold" }}>
              Welcome to ASG Ccnnect Conference 2025!
            </span>
            <br />
            <br />
            We are thrilled to invite you to an unforgettable experience of
            innovation, connection, and inspiration. This is where the future of
            Actuarial innovation, talent discovery and nurturing, businesses,
            partnerships and learning takes place and shape. <br />
            <br /> Get ready to dive deep with world-class speakers, connect
            with brilliant peers, and discover the tools and ideas that will
            propel you forward. The energy is building, and we can't wait to see
            you there. <br />
            <br /> Let's build what's next, together. <br />
            <br />
            <span style={{ fontWeight: "bold" }}>Kofi Ntim ASG</span>
            <br />
            <span style={{ fontWeight: "bold" }}>President</span>
          </p>
        </div>
        {/* ====== Conference Cards Section ====== */}
        <section
          className="card-section"
          style={{
            display: "flex",
            flexDirection: "row",
            alignSelf: "center",
            margin: "0px",
            justifySelf: "center",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div
            className="accreditation-card"
            onClick={() => setShowModal(true)}
            style={{ cursor: "pointer" }}
          >
            <GraduationCap className="uni-icon" />
            <h1 className="uni-title">REGISTRATION</h1>
          </div>

          {/* <div className="accreditation-card">
          <GraduationCap className="uni-icon" />
          <h1 className="uni-title">SPEAKERS</h1>
        </div> */}

          <div
            className="accreditation-card exemption-card"
            onClick={() => setShowProgrammeOutline(true)}
            style={{ cursor: "pointer" }}
          >
            <BookOpen className="uni-icon" />
            <h1 className="uni-title">PROGRAMME</h1>
          </div>

          <div className="accreditation-card exemption-card">
            <BookOpen className="uni-icon" />
            <h1 className="uni-title">SPONSORS</h1>
          </div>
        </section>

        {/*Gallery*/}
        <section
          className="news-section"
          style={{
            marginLeft: "85px",
            width: "80%",
            alignSelf: "center",
            zIndex: "100000",
          }}
        >
          <h2 className="news-heading">SPEAKERS</h2>
          <div className="news-carousel">
            <button className="arrow-btn left-arrow" onClick={prevNews}>
              <FaArrowLeft />
            </button>
            <div
              className="news-cards"
              style={{
                width: "700px",
                margin: "20px",
                justifySelf: "center",
                alignSelf: "center",
              }}
            >
              {visibleNews.map((news) => (
                <div
                  key={news.id}
                  className="news-card"
                  style={{ height: "300px" }}
                >
                  <img
                    src={news.image}
                    alt={news.title}
                    className="news-image"
                  />
                </div>
              ))}
            </div>
            <button className="arrow-btn right-arrow" onClick={nextNews}>
              <FaArrowRight />
            </button>
          </div>
        </section>

        {/* <div
          onClick={() => {
            setShowProgrammeOutline(true);
          }}
          style={{
            backgroundColor: "#00064d",
            color: "white",
            padding: "10px 10px",
            borderRadius: "10px",
            textAlign: "center",
            cursor: "pointer"
          }}
        >
          View Programme Outline
        </div> */}
      </div>
      {/* Registration Modal */}
      <ASGConnect2025Registration
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />

      {/* Programme Outline Modal */}
      <ProgrammeOutline
        isOpen={showProgrammeOutline}
        onClose={() => setShowProgrammeOutline(false)}
      />
    </div>
  );
};

export default ASGConnect2025;
